<template>
  <div>
    <div v-if="isLoading">
      <br /><br /><br /><br />
      <br /><br /><br /><br />
      <v-progress-circular :size="200" :width="7" color="blue" indeterminate
        ><b></b
      ></v-progress-circular>
    </div>
    <div v-if="!isLoading" class="clear-flow">
      <v-container id="mobilePanelContainer" fluid class="grey lighten-5">
        <v-dialog v-model="requestDialog" persistent width="600">
          <v-card class="pa-4">
            <div class="pb-2">
              <v-card-title
                class="text-h7 px-0 pb-0 text-center flex justify-center"
              >
                <span v-if="activeRequest.request_type == 'PAC Request'"
                  >Confirm Send PAC Request</span
                >
                <span v-if="activeRequest.request_type == 'SIM Swap'"
                  >SIM Swap</span
                >
                <span v-if="activeRequest.request_type == 'Barring Change'"
                  >Barring Change</span
                >
                <span v-if="activeRequest.request_type == 'Cost Centre Change'"
                  >Cost Centre Change</span
                >
                <span v-if="activeRequest.request_type == 'User Name Change'"
                  >User Name Change</span
                >
                <span v-if="activeRequest.request_type == 'Unlatch Request'"
                  >Unlatch Request</span
                >
              </v-card-title>
            </div>
            <div v-if="activeRequest.request_type == 'Unlatch Request'">
              <v-text-field
                v-model="activeRequest.request_details[0].imei"
                label="IMEI number"
                prepend-inner-icon="mdi-cellphone"
                hint="Must be a valid IMEI number (15 digits in length)"
                clearable
                outlined
                dense
                persistent-hint
              ></v-text-field>
            </div>
            <div v-if="activeRequest.request_type == 'SIM Swap'">
              <v-text-field
                v-model="activeRequest.request_details[0].sim_number"
                label="Enter New SIM Number"
                prepend-inner-icon="mdi-sim"
                hint="SIM must be numeric. It should start with 894411006, followed by 10 digits"
                clearable
                outlined
                dense
                persistent-hint
              ></v-text-field>
            </div>

            <div v-if="activeRequest.request_type == 'Barring Change'">
              <v-select
                class="mb-4"
                label="Select Bar Type"
                :items="[
                  'full_bar',
                  'gprs_bar',
                  'imei_bar',
                  'roaming_bar',
                  'over_18_content_bar',
                ]"
                prepend-inner-icon="mdi-cellphone-off"
                v-model="activeRequest.request_details[0].bar_type"
                dense
                solo
                outlined
                hide-details
                persistent-hint
                hint="Bar type"
              ></v-select>
            </div>
            <div v-if="activeRequest.request_type == 'Cost Centre Change'">
              <v-text-field
                label="Enter Cost Centre"
                v-model="activeRequest.request_details[0].cost_centre"
                prepend-inner-icon="mdi-cash"
                hint="Cost centre must be alphanumeric and not exceed 20 digits"
                clearable
                outlined
                dense
                persistent-hint
              >
                {{ this.activeRequest.request_details }}
              </v-text-field>
            </div>
            <div v-if="activeRequest.request_type == 'User Name Change'">
              <v-text-field
                v-model="activeRequest.request_details[0].username"
                label="Enter New Username"
                prepend-inner-icon="mdi-account-circle"
                clearable
                hint="Username must be between 1 and 30 characters in length"
                outlined
                dense
                persistent-hint
              ></v-text-field>
            </div>

            <div
              v-if="showServiceRequestErrorMessage"
              style="color: red"
              class="mb-4"
            >
              {{ serviceRequestErrorMessage }}
            </div>

            <div>
              <v-btn
                v-if="activeRequest.request_type == 'Barring Change'"
                color="green darken-1 font-weight-bold"
                text
                @click="activeRequest.request_details[0].enabled = false; serviceRequestConfirm()"
              >
                REMOVE BAR
              </v-btn>


              <v-btn
                v-if="activeRequest.request_type == 'Barring Change'"
                color="green darken-1 font-weight-bold"
                text
                @click="activeRequest.request_details[0].enabled = true; serviceRequestConfirm()"
              >
                ADD BAR
              </v-btn>

              <v-btn
                v-if="activeRequest.request_type != 'Barring Change'"
                color="green darken-1 font-weight-bold"
                text
                @click="serviceRequestConfirm()"
              >
                CONFIRM
              </v-btn>
              <v-btn
                color="green darken-1 font-weight-bold"
                text
                @click="requestDialog = !requestDialog"
              >
                CANCEL
              </v-btn>
            </div>
          </v-card>
        </v-dialog>

        <!-- Top Level Row -->
        <v-row>
          <!-- Left Side -->
          <v-col cols="7" class="pb-0">
            <!-- Top Three Cards -->
            <v-row>
              <v-col cols="4">
                <info-card
                  :titleLink="linkToFilteredSubscriptionDataTable"
                  :title="formattedMobileNumber"
                  titleIconHoverText="Click to copy mobile number to clipboard"
                  titleIcon="mdi-content-copy"
                  :cardFieldNameValuePairs="numberInfoBlockPairs"
                  :maxStringCharacterLengthDataCard="
                    maxStringCharacterLengthDataCard
                  "
                  :iconClickFunction="copyNumberToClipboard"
                  class="min-width-modile-info-card"
                >
                </info-card>
              </v-col>

              <v-col cols="4">
                <info-card
                  title="Contract Information"
                  :cardFieldNameValuePairs="contractInformationInfoBlockPairs"
                  :maxStringCharacterLengthDataCard="
                    maxStringCharacterLengthDataCard
                  "
                  class="min-width-modile-info-card"
                >
                </info-card>
              </v-col>
              <v-col cols="4">
                <info-card
                  title="Tariff Information"
                  :cardFieldNameValuePairs="tariffInformationInfoBlockPairs"
                  :maxStringCharacterLengthDataCard="
                    maxStringCharacterLengthDataCard
                  "
                  class="min-width-modile-info-card"
                >
                </info-card>
              </v-col>
            </v-row>

            <!-- Second Row Three Cards -->
            <v-row class="pt-2">
              <v-col cols="4">
                <info-card
                  :titleLink="linkToFilteredInvoiceDataTable"
                  title="Invoice Information"
                  :cardFieldNameValuePairs="invoiceInformationBlockPairs"
                  :maxStringCharacterLengthDataCard="
                    maxStringCharacterLengthDataCard
                  "
                  class="min-width-modile-info-card"
                >
                </info-card>
              </v-col>

              <v-col cols="4">
                <info-card
                  title="Spend Cap Information"
                  :cardFieldNameValuePairs="spendCapInformationBlockPairs"
                  :maxStringCharacterLengthDataCard="
                    maxStringCharacterLengthDataCard
                  "
                  :titleIconHoverText="spendCapText"
                  titleIcon="mdi-information-outline"
                  class="min-width-modile-info-card"
                >
                </info-card>
              </v-col>
              <v-col cols="4">
                <info-card
                  title="Subscription Information"
                  :cardFieldNameValuePairs="subscriptionInformationBlockPairs"
                  :maxStringCharacterLengthDataCard="
                    maxStringCharacterLengthDataCard
                  "
                  class="min-width-modile-info-card"
                >
                </info-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6" class="mt-2 pb-0">
                <!-- Bundle Usage Card -->
                <v-card id="bundleCard" class="mb-5 pa-2" ripple>
                  <v-container class="pb-0 pt-0 pl-0 pr-0 d-flex" fluid>
                    <v-row>
                      <v-col cols="12" class="text-left">
                        <v-chip class="med-chip" label small text-color="black">
                          <b
                            >{{ this.currentDataUsage }} GB Data Used During
                            Active Billing Period</b
                          >
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>

                <v-card id="bundleCard" ripple height="405px">
                  <v-container
                    class="pb-0 pt-0 pl-0 pr-0 d-flex"
                    v-if="numberOfBundles > 0"
                  >
                    <v-col cols="5" class="pb-2 mr-0 text-left">
                      <router-link
                        class="font-weight-black mb-0"
                        :to="linkToFilteredBundleDataTable"
                        >Bundle Usage ({{ numberOfBundles }})
                      </router-link>
                    </v-col>
                    <v-col cols="3" class="pb-2 pr-0 pl-0 text-right">
                      <v-chip
                        class="pa-3 med-chip"
                        label
                        small
                        color="blue"
                        text-color="white"
                        @click="toggleExpiredBundles()"
                      >
                        <b
                          >Expired&nbsp;&nbsp;
                          <v-icon small left v-if="showingExpiredForBundles">
                            mdi-check
                          </v-icon>

                          <v-icon small left v-if="!showingExpiredForBundles">
                            mdi-close
                          </v-icon></b
                        >
                      </v-chip>
                    </v-col>
                    <v-col cols="4" class="pb-2 text-left">
                      <v-chip
                        class="pa-3 med-chip"
                        label
                        small
                        color="blue"
                        text-color="white"
                      >
                        <v-dialog v-model="dialog" persistent width="400">
                          <template v-slot:activator="{ on, attrs }">
                            <a v-on="on" v-bind="attrs" class="white--text"
                              ><b>Order: {{ bundleOrderText }}</b></a
                            >
                          </template>
                          <v-card>
                            <v-card-title class="text-h7">
                              Order Bundle Usage By:
                            </v-card-title>

                            <v-container fluid class="pt-0 pb-0">
                              <v-radio-group
                                mandatory
                                v-model="bundleOrderByUsage"
                                row
                                class="pl-2"
                              >
                                <v-radio
                                  label="Bundle Usage"
                                  value="true"
                                ></v-radio>
                                <v-radio
                                  label="Bundle Start Date"
                                  value="false"
                                ></v-radio>
                              </v-radio-group>
                            </v-container>
                            <v-card-actions>
                              <v-btn
                                color="green darken-1 font-weight-bold"
                                text
                                @click="
                                  dialog = false;
                                  orderBundleUsage();
                                "
                              >
                                CONFIRM
                              </v-btn>
                              <v-btn
                                color="green darken-1 font-weight-bold"
                                text
                                @click="dialog = false"
                              >
                                CANCEL
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </v-chip>
                    </v-col>
                  </v-container>
                  <v-divider></v-divider>
                  <div v-if="numberOfBundles == 0">
                    <br />
                    <span>No Bundles For This Number</span>
                  </div>

                  <v-virtual-scroll
                    :items="visibleBundles"
                    item-height="67.5"
                    height="359px"
                  >
                    <template v-slot:default="{ item }">
                      <v-list-item :key="item.id" track>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-row>
                              <v-container class="pb-0 pt-0 d-flex">
                                <v-col cols="10" class="text-left pb-0">
                                  <p
                                    class="font-weight-medium grey-text small-font"
                                  >
                                    {{ item.bundleDescription }} ({{
                                      item.bundleCode
                                    }})

                                    <br />

                                    {{
                                      item.bundleEffectiveDate.dayOfMonth +
                                      "/" +
                                      item.bundleEffectiveDate.monthValue +
                                      "/" +
                                      item.bundleEffectiveDate.year
                                    }}
                                    <v-icon small aria-hidden="false">
                                      mdi-arrow-right
                                    </v-icon>
                                    {{
                                      item.bundleExpiryDate.dayOfMonth +
                                      "/" +
                                      item.bundleExpiryDate.monthValue +
                                      "/" +
                                      item.bundleExpiryDate.year
                                    }}
                                  </p>
                                </v-col>
                                <v-col cols="2" class="text-right pb-0 mt-3">
                                  <span
                                    class="font-weight-medium grey-text small-font"
                                  >
                                    {{
                                      (
                                        100 - item.bundleNotUsedPercentage
                                      ).toFixed(2)
                                    }}%
                                  </span>
                                </v-col>
                              </v-container>
                            </v-row>
                            <v-row class="mt-0">
                              <v-container class="pb-0 pt-0">
                                <v-col cols="12" class="text-left pt-0">
                                  <!-- getProgressBarColor() -->
                                  <v-progress-linear
                                    color="maintel-dark-green"
                                    :height="10"
                                    :value="100 - item.bundleNotUsedPercentage"
                                  >
                                  </v-progress-linear>
                                </v-col>
                              </v-container>
                            </v-row>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                    </template>
                  </v-virtual-scroll>
                </v-card>
              </v-col>

              <!-- Pie Chart -->
              <v-col cols="6" class="mt-2 pb-0">
                <v-card
                  id="donutCard"
                  ripple
                  hover
                  class="pb-4"
                  height="465px"
                  :to="linkToFilteredMobileSpendDataTable"
                >
                  <p class="font-weight-black pt-3 mb-2 mb-0">
                    <router-link :to="linkToFilteredMobileSpendDataTable">
                      Out Of Bundle Spend By Classification</router-link
                    >
                  </p>
                  <v-divider></v-divider>
                  <div class="d-flex pa-2 pt-7 justify-center pt-0">
                    <div id="chart">
                      <apexchart
                        type="donut"
                        width="450"
                        :options="chartOptions"
                        :series="series"
                      ></apexchart>
                    </div>
                  </div>
                </v-card>
                <br />
              </v-col>
            </v-row>
          </v-col>

          <!-- Right Side -->
          <v-col cols="5" class="pb-0">
            <v-card
              v-if="
                settings.roles.includes('mp_selfservice') ||
                settings.roles.includes(
                  'mp_selfservice_alert_readonly'
                ) ||
                settings.roles.includes('mp_admin')
              "
              id="serviceRequestCard"
              ripple
              class="pb-5 lighten-4 mb-5"
              height="195px"
            >
              <p class="font-weight-black pt-3 mb-2">
                <!-- Service Requests -->Service Requests &nbsp;
              </p>
              <v-divider></v-divider>
              <v-col cols="12">
                <v-row>
                  <v-container class="d-flex pb-0 pt-0 mt-4">
                    <v-col cols="6" class="text-left pt-0 pb-0">
                      <v-btn
                        outlined
                        small
                        color="maintel-dark-green"
                        class="text-none"
                        block
                        @click="startServiceRequest('User Name Change')"
                        ><b>User Name Change</b></v-btn
                      >
                    </v-col>
                    <v-col cols="6" class="text-left pt-0 pb-0">
                      <v-btn
                        outlined
                        small
                        color="maintel-dark-green"
                        class="text-none"
                        block
                        @click="startServiceRequest('SIM Swap')"
                        ><b>SIM Swap</b></v-btn
                      >
                    </v-col>
                  </v-container>
                </v-row>
                <v-row class="mt-7">
                  <v-container class="d-flex pb-0 pt-0">
                    <v-col cols="6" class="text-left pt-0 pb-0">
                      <v-btn
                        outlined
                        small
                        color="maintel-dark-green"
                        class="text-none"
                        block
                        @click="startServiceRequest('Barring Change')"
                        ><b>Barring Change</b></v-btn
                      >
                    </v-col>
                    <v-col cols="6" class="text-left pt-0 pb-0">
                      <v-btn
                        outlined
                        small
                        color="maintel-dark-green"
                        class="text-none"
                        block
                        @click="startServiceRequest('Cost Centre Change')"
                        ><b>Cost Centre Change</b></v-btn
                      >
                    </v-col>
                  </v-container>
                </v-row>

                <v-row class="mt-7">
                  <v-container class="d-flex pb-0 pt-0">
                    <v-col cols="6" class="text-left pt-0 pb-0">
                      <v-btn
                        outlined
                        small
                        color="maintel-dark-green"
                        class="text-none"
                        block
                        @click="startServiceRequest('PAC Request')"
                        ><b>PAC Request</b></v-btn
                      >
                    </v-col>
                    <v-col cols="6" class="text-left pt-0 pb-0">
                      <v-btn
                        outlined
                        small
                        color="maintel-dark-green"
                        class="text-none"
                        block
                        @click="startServiceRequest('Unlatch Request')"
                        ><b>Unlatch Request</b></v-btn
                      >
                    </v-col>
                  </v-container>
                </v-row>
              </v-col>
            </v-card>

            <!-- Mobile Services Card -->
            <v-card id="mobileServicesCard" ripple height="34.5%" width="100%">
              <v-container class="pb-0 pt-0 pl-0 pr-3 d-flex">
                <v-col cols="3" class="pb-2 pl-0 ml-3 mr-0 text-left">
                  <router-link
                    class="font-weight-black mb-0"
                    :to="linkToFilteredServicesDataTable"
                    >Services ({{ numberOfServices }})
                  </router-link>
                </v-col>
                <v-col cols="3" class="pb-2 text-right">
                  <v-chip
                    @click="toggleZeroSpendServices()"
                    class="med-chip"
                    label
                    small
                    color="blue"
                    text-color="white"
                  >
                    <b
                      >Zero Spend&nbsp;&nbsp;
                      <v-icon small left v-if="showingZeroSpendForServices">
                        mdi-check
                      </v-icon>
                      <v-icon small left v-if="!showingZeroSpendForServices">
                        mdi-close
                      </v-icon></b
                    >
                  </v-chip>
                </v-col>
                <v-col cols="3" class="pb-2 pl-0 text-right">
                  <v-chip
                    @click="toggleExpiredServices()"
                    class="med-chip"
                    label
                    small
                    color="blue"
                    text-color="white"
                  >
                    <b
                      >Expired&nbsp;&nbsp;
                      <v-icon small left v-if="showingExpiredForServices">
                        mdi-check
                      </v-icon>
                      <v-icon small left v-if="!showingExpiredForServices">
                        mdi-close
                      </v-icon></b
                    >
                  </v-chip>
                </v-col>

                <v-col cols="3" class="pb-2 ma-0 pl-0">
                  <v-chip
                    class="med-chip"
                    label
                    small
                    color="blue"
                    text-color="white"
                  >
                    <v-dialog v-model="serviceDialog" persistent width="400">
                      <template v-slot:activator="{ on, attrs }">
                        <a v-on="on" v-bind="attrs" class="white--text"
                          ><b>Order: {{ serviceOrderText }}</b></a
                        >
                      </template>
                      <v-card>
                        <v-card-title class="text-h7">
                          Order Mobile Services By:
                        </v-card-title>

                        <v-container fluid class="pt-0 pb-0">
                          <v-radio-group
                            mandatory
                            v-model="serviceOrderByPrice"
                            row
                            class="pl-2"
                          >
                            <v-radio
                              label="Service Price"
                              value="true"
                            ></v-radio>
                            <v-radio
                              label="Service Start Date"
                              value="false"
                            ></v-radio>
                          </v-radio-group>
                        </v-container>
                        <v-card-actions>
                          <v-btn
                            color="green darken-1 font-weight-bold"
                            text
                            @click="
                              serviceDialog = false;
                              orderServices();
                            "
                          >
                            CONFIRM
                          </v-btn>
                          <v-btn
                            color="green darken-1 font-weight-bold"
                            text
                            @click="serviceDialog = false"
                          >
                            CANCEL
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-chip>
                </v-col>
              </v-container>

              <v-divider></v-divider>

              <div v-if="numberOfServices == 0">
                <br />
                <span>No Services For This Number</span>
              </div>

              <v-virtual-scroll
                :items="visibleServices"
                height="230"
                item-height="65"
              >
                <template v-slot:default="{ item }">
                  <v-list-item :key="item.id" track>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-row>
                          <v-container class="pb-0 pt-0 d-flex">
                            <v-col cols="6" class="pb-0 text-left">
                              <p
                                class="font-weight-medium grey-text medium-font"
                              >
                                {{ item.serviceDescription }} ({{
                                  item.serviceCode
                                }})

                                <br />
                                <b
                                  >{{
                                    item.serviceEffectiveDate.dayOfMonth +
                                    "/" +
                                    item.serviceEffectiveDate.monthValue +
                                    "/" +
                                    item.serviceEffectiveDate.year
                                  }}&nbsp;

                                  <span v-if="item.serviceExpiryDate != null">
                                    <v-icon
                                      small
                                      class="is-grey"
                                      aria-hidden="false"
                                      >mdi-arrow-right</v-icon
                                    >&nbsp;&nbsp;{{
                                      item.serviceExpiryDate.dayOfMonth +
                                      "/" +
                                      item.serviceExpiryDate.monthValue +
                                      "/" +
                                      item.serviceExpiryDate.year
                                    }}
                                  </span>
                                </b>
                              </p>
                            </v-col>

                            <v-col cols="6" class="text-right">
                              <v-chip
                                class="mt-2 mr-2 short-chip"
                                label
                                small
                                border
                              >
                                <b>£{{ item.servicePrice.toFixed(2) }}</b>
                              </v-chip>
                            </v-col>
                          </v-container>
                        </v-row>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </template>
              </v-virtual-scroll>
            </v-card>

            <v-card
              id="recentRequestsCard"
              ripple
              height="288px"
              width="100%"
              class="mt-5 lighten-4"
            >
              <v-container class="pb-0 pt-0">
                <v-col cols="12" class="pb-2">
                  <p class="font-weight-black mb-0">
                    <router-link :to="linkToFilteredBundleDataTable">
                      Bundle Data Usage Over Time</router-link
                    >
                  </p>
                </v-col>
              </v-container>
              <v-divider></v-divider>
              <div class="d-flex pa-2 mt-3 justify-center pt-0">
                <div>
                  <apexchart
                    width="600"
                    height="220"
                    :options="lineChartOptions"
                    :series="lineChartOptions.series"
                  ></apexchart>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mb-1 mt-5">
          <v-col class="pt-0">
            <v-card ripple id="requestsCard">
              <div>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="text-h7 font-weight-black">
                      <div class="d-flex pa-2 pb-0 pt-0 pl-0">
                        <v-col cols="6" class="pt-1 pl-0 pb-0 text-left">
                          <div class="pt-small">
                            Recent Service Requests Made ({{
                              numberOfRequests
                            }})
                          </div>
                        </v-col>
                        <v-col cols="6" class="pt-0 pb-0 ml-5 text-right">
                          <v-btn
                            outlined
                            small
                            color="maintel-dark-green"
                            class="text-none"
                            :to="this.linkToServiceRequests"
                            ><b
                              >Service Requests For
                              {{
                                this.mobileSummary.mpnFixedLineDigitalAccountEtc
                              }}</b
                            ></v-btn
                          >
                        </v-col>
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left medium-font font-weight-light">
                          Request Type
                        </th>
                        <th class="text-left medium-font font-weight-light">
                          Date/Time
                        </th>
                        <th class="text-left medium-font font-weight-light">
                          Request Details
                        </th>
                        <th class="text-left medium-font font-weight-light">
                          Error
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(service, index) in mobileSummary.recentRequests"
                        :key="index"
                      >
                        <td class="text-left">{{ service.request_type }}</td>
                        <td class="text-left">
                          {{
                            new Date(service.created)
                              .toString()
                              .substring(0, 24)
                          }}
                        </td>
                        <td class="text-left">
                          <span v-if="service.bar_type">
                            <v-chip
                              small
                              color="indigo"
                              text-color="white"
                              class="mx-2"
                              label
                              >Bar Type</v-chip
                            >
                            {{ service.bar_type }}&nbsp;<span v-if="service.enabled">(Bar Added)</span><span v-if="!service.enabled">(Bar Removed)</span>
                          </span>
                          <span v-if="service.cost_centre">
                            <v-chip
                              small
                              color="indigo"
                              text-color="white"
                              class="mx-2"
                              label
                              >Cost Centre</v-chip
                            >

                            {{ service.cost_centre }}</span
                          >

                          <span v-if="service.imei">
                            <v-chip
                              small
                              color="indigo"
                              text-color="white"
                              class="mx-2"
                              label
                              >IMEI</v-chip
                            >

                            {{ service.imei }}</span
                          >

                          <span v-if="service.username">
                            <v-chip
                              small
                              color="indigo"
                              text-color="white"
                              class="mx-2"
                              label
                              >Username</v-chip
                            >

                            {{ service.username }}</span
                          >
                          <span v-if="service.sim_number">
                            <v-chip
                              small
                              color="indigo"
                              text-color="white"
                              class="mx-2"
                              label
                              >SIM Number</v-chip
                            >

                            {{ service.sim_number }}</span
                          >
                          <span v-if="service.status">
                            <v-chip
                              small
                              color="indigo"
                              text-color="white"
                              class="mx-2"
                              label
                              >Status</v-chip
                            >

                            {{ service.status }}</span
                          >
                        </td>
                        <td class="text-left">
                          {{ service.validation_errors }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar">
      Number Copied to Clipboard
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import moment from "moment";
import ToolTip from "./ToolTip.vue";
import InfoCard from "./InfoCard.vue";

export default {
  components: {
    apexchart: VueApexCharts,
    ToolTip,
    InfoCard,
  },
  props: {
    settings: Object,
  },
  data() {
    return {
      isLoading: true,
      mobileSummary: {
        userName: "",
        groupCode: "",
        corpoCode: "",
        contractStatus: "",
        contractStart: {},
        contractEnd: {},
        tariffName: "",
        tarriffCode: "",
        tariffDescription: "",
        tariffStartDate: {},
        hasSpendCap: false,
        spendCapUsed: 0,
        spendCapAmount: 0,
        contractLength: 0,
        billedCallPriceByClassType: [],
        bundleUsage: [],
        services: [],
        recentRequests: [],
        mpnFixedLineDigitalAccountEtc: "",
        subNumber: 0,
        subscriptionStatus: "",
        agreementNumber: 0,
        statusReason: "",
        simCardSerialNumber: "",
        paymentType: "",
        nextInvoiceDate: {},
        lastInvoiceDate: {},
        lastInvoiceAmountGrossTax: 0,
        connectedDate: {},
        disconnectedDate: {},
        costCentre: "",
      },
      numberOfServicesToShow: 0,
      maxStringCharacterLengthDataCard: 20,
      numberOfRequestsToShow: 0,
      numberOfBundles: 0,
      currentDataUsage: 0,
      formattedMobileNumber: "No Subscription Data",
      contractStartDateString: "",
      contractEndDateString: "",
      tarriffStartDateString: "",
      lastInvoiceDateString: "",
      nextInvoiceDateString: "",
      connectedDateString: "",
      disconnectedDateString: "",
      linkToFilteredInvoiceDataTable: "",
      linkToFilteredBundleDataTable: "",
      linkToFilteredServicesDataTable: "",
      linkToFilteredSubscriptionDataTable: "",
      linkToFilteredMobileSpendDataTable: "",
      linkToServiceRequests: "",
      spendCapText: "",
      snackbar: false,
      dialog: false,
      requestDialog: false,
      bundleOrderByUsage: true,
      serviceOrderByPrice: true,
      bundleOrderText: "Usage",
      serviceOrderText: "Price",
      contractStatus: "",
      tariffDescription: "",
      tariffName: "",
      numberOfRequests: 0,
      userName: "",
      numberOfServices: 0,
      totalSpend: 0,
      series: [],
      visibleBundles: [],
      visibleServices: [],
      contractInformationInfoBlockPairs: [],
      tariffInformationInfoBlockPairs: [],
      numberInfoBlockPairs: [],
      invoiceInformationBlockPairs: [],
      spendCapInformationBlockPairs: [],
      subscriptionInformationBlockPairs: [],
      showingExpiredForBundles: false,
      showingExpiredForServices: true,
      showingZeroSpendForServices: true,
      showServiceRequestErrorMessage: false,
      serviceRequestErrorMessage: "",
      serviceRequestConfirmMessage: "",
      activeRequest: {
        request_type: "",
        request_details: [],
      },
      serviceDialog: false,
      chartOptions: {
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: "OOB Spend",
                  fontSize: "18px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  color: "#373d3f",
                  formatter: function (w) {
                    var totalValue =
                      "£" +
                      w.globals.seriesTotals
                        .reduce((a, b) => {
                          return a + b;
                        }, 0)
                        .toLocaleString();

                    return totalValue;
                  },
                },
              },
            },
          },
        },
        stroke: {
          show: true,
          colors: ["black"],
          width: 2,
        },
        chart: {
          type: "donut",
        },
        legend: {
          show: false,
        },
        labels: [],
        tooltip: {
          y: {
            formatter: function (value) {
              return "£" + value.toFixed(2);
            },
          },
        },
      },
      lineChartOptions: {
        series: [],
        tooltip: {
          shared: false,
          intersect: true,
        },
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: true,
          },
          toolbar: {
            show: true,
            tools: {
              download: false,
            },
          },
        },
        stroke: {
          width: 5,
          curve: "smooth",
        },
        title: {
          text: "Data Usage (GB)",
          align: "left",
        },
        markers: {
          size: 4,
        },
        xaxis: {
          categories: [],
        },
        yaxis: [
          {
            labels: {
              formatter: function (val) {
                return val.toFixed(2);
              },
            },
          },
        ],
        grid: {
          borderColor: "#f1f1f1",
        },
      },
    };
  },
  methods: {
    serviceRequestConfirm() {
      switch (this.activeRequest.request_type) {
        case "User Name Change":
          this.serviceRequestConfirmMessage =
            "Are you sure you want to change the username for " +
            this.$route.params.mobilenumber +
            " to " +
            this.activeRequest.request_details[0].username;
          break;
        case "SIM Swap":
          this.serviceRequestConfirmMessage =
            "Are you sure you want swap the SIM number for " +
            this.$route.params.mobilenumber +
            " to " +
            this.activeRequest.request_details[0].sim_number;
          break;
        case "Barring Change":
          if (this.activeRequest.request_details[0].enabled) {
            this.serviceRequestConfirmMessage =
              "Are you sure you want to add a " +
              this.activeRequest.request_details[0].bar_type +
              " to " +
              this.$route.params.mobilenumber;
          } else {
            this.serviceRequestConfirmMessage =
              "Are you sure you want to remove a " +
              this.activeRequest.request_details[0].bar_type +
              " from " +
              this.$route.params.mobilenumber;
          }
          break;
        case "Cost Centre Change":
          this.serviceRequestConfirmMessage =
            "Are you sure you want to change the cost centre for " +
            this.$route.params.mobilenumber +
            " to " +
            this.activeRequest.request_details[0].cost_centre;
          break;
        case "Unlatch Request":
          this.serviceRequestConfirmMessage =
            "Are you sure you want to make an unlatch request for IMEI " +
            this.activeRequest.request_details[0].imei;
          break;
        case "PAC Request":
          this.serviceRequestConfirmMessage =
            "Are you sure you want to submit a PAC request for " +
            this.$route.params.mobilenumber;
          break;
      }

      this.serviceRequestConfirmMessage +=
        "? Service requests may be irreversible.";

      this.$confirm(this.serviceRequestConfirmMessage).then(() => {
        this.showServiceRequestErrorMessage = false;

        switch (this.activeRequest.request_type) {
          case "User Name Change":
            if (
              !this.activeRequest.request_details[0].username ||
              this.activeRequest.request_details[0].username.trim().length ==
                0 ||
              this.activeRequest.request_details[0].username.trim().length > 30
            ) {
              this.showServiceRequestErrorMessage = true;
              this.serviceRequestErrorMessage =
                "Please supply a valid username. A username must be less than 30 and greater than 0 characters in length";
            }

            break;
          case "SIM Swap":
            console.log(
              "this.activeRequest.request_details[0].sim_number",
              this.activeRequest.request_details[0].sim_number
            );

            if (
              !this.activeRequest.request_details[0].sim_number ||
              this.activeRequest.request_details[0].sim_number.trim().length ==
                0 ||
              !/^(894411006)[0-9]{10}$/.test(
                this.activeRequest.request_details[0].sim_number
              )
            ) {
              this.showServiceRequestErrorMessage = true;
              this.serviceRequestErrorMessage =
                "SIM number is invalid. Please supply a valid SIM number. ";
            }

            break;
          case "Barring Change":
            if (
              !this.activeRequest.request_details[0].bar_type ||
              this.activeRequest.request_details[0].bar_type.trim().length == 0
            ) {
              this.showServiceRequestErrorMessage = true;
              this.serviceRequestErrorMessage = "You must select a bar type";
            }

            break;
          case "Cost Centre Change":
            // Check if it's alphanumeric.
            if (
              !this.activeRequest.request_details[0].cost_centre ||
              !/^[a-z0-9]+$/i.test(
                this.activeRequest.request_details[0].cost_centre
              ) ||
              this.activeRequest.request_details[0].cost_centre.trim().length >
                20
            ) {
              this.showServiceRequestErrorMessage = true;
              this.serviceRequestErrorMessage =
                "Cost centre must be alphanumeric and not exceed 20 digits in length";
            }

            break;
          case "Unlatch Request":
            if (
              !this.activeRequest.request_details[0].imei ||
              !/^\d{15}$/.test(this.activeRequest.request_details[0].imei)
            ) {
              this.showServiceRequestErrorMessage = true;
              this.serviceRequestErrorMessage =
                "You must enter a valid IMEI number";
            }

            break;
        }

        if (this.showServiceRequestErrorMessage) return;
        else this.requestDialog = false;

        console.log("Active request lado", this.activeRequest);

        axios
          .post("api/proposition/service-request", this.activeRequest)
          .then((response) => {
            console.log("response.data", response.data);
            this.mobileSummary.recentRequests.unshift(response.data);
            this.numberOfRequests += 1;
          })
          .catch((error) => {
            console.log("error", error);
            alert(error);
          });
      });
    },
    getProgressBarColor() {
      return "hsla(" + ~~(360 * Math.random()) + "," + "40%," + "50%,1)";
    },
    startServiceRequest(requestType) {
      this.showServiceRequestErrorMessage = false;
      this.activeRequest.request_type = requestType;

      this.activeRequest.request_details = [
        {
          mpn: this.$route.params.mobilenumber,
        },
      ];

      switch (requestType) {
        case "User Name Change":
          this.activeRequest.request_details[0]["username"] = "";
          break;
        case "SIM Swap":
          this.activeRequest.request_details[0]["sim_number"] = "";
          break;
        case "Barring Change":
          this.activeRequest.request_details[0]["bar_type"] = "";
          this.activeRequest.request_details[0]["enabled"] = true;
          break;
        case "Cost Centre Change":
          this.activeRequest.request_details[0]["cost_centre"] = "";
          break;
        case "Unlatch Request":
          this.activeRequest.request_details[0]["imei"] = "";
          break;
      }

      this.requestDialog = !this.requestDialog;
    },
    formatUserName(sentenceCase) {
      return sentenceCase;
    },
    orderServices() {
      if (this.serviceOrderByPrice == "true") {
        this.serviceOrderText = "Price";
        this.visibleServices.sort(function (a, b) {
          return a.servicePrice < b.servicePrice ? 1 : -1;
        });
      } else if (this.serviceOrderByPrice == "false") {
        this.serviceOrderText = "Date";

        this.visibleServices.sort(function (a, b) {
          var aDate =
            a.serviceEffectiveDate.year +
            "/" +
            a.serviceEffectiveDate.monthValue +
            "/" +
            a.serviceEffectiveDate.dayOfMonth;
          var bDate =
            b.serviceEffectiveDate.year +
            "/" +
            b.serviceEffectiveDate.monthValue +
            "/" +
            b.serviceEffectiveDate.dayOfMonth;

          return new Date(aDate).getTime() < new Date(bDate).getTime() ? 1 : -1;
        });
      }
    },
    orderBundleUsage() {
      if (this.bundleOrderByUsage == "true") {
        this.bundleOrderText = "Usage";
        this.visibleBundles.sort(function (a, b) {
          return a.bundleNotUsedPercentage > b.bundleNotUsedPercentage ? 1 : -1;
        });
      } else if (this.bundleOrderByUsage == "false") {
        this.bundleOrderText = "Date";
        this.visibleBundles.sort(function (a, b) {
          var aDate =
            a.bundleExpiryDate.year +
            "/" +
            a.bundleExpiryDate.monthValue +
            "/" +
            a.bundleExpiryDate.dayOfMonth;
          var bDate =
            b.bundleExpiryDate.year +
            "/" +
            b.bundleExpiryDate.monthValue +
            "/" +
            b.bundleExpiryDate.dayOfMonth;

          return new Date(aDate).getTime() < new Date(bDate).getTime() ? 1 : -1;
        });
      }
    },
    toggleExpiredBundles() {
      this.visibleBundles = [];
      var currentDate = moment().toDate();
      this.showingExpiredForBundles = !this.showingExpiredForBundles;

      for (var index in this.mobileSummary.bundleUsage) {
        var bundle = this.mobileSummary.bundleUsage[index];
        var bDate =
          bundle.bundleExpiryDate.dayOfMonth +
          "/" +
          bundle.bundleExpiryDate.monthValue +
          "/" +
          bundle.bundleExpiryDate.year;
        var bundleDate = moment(bDate, "DD/MM/YYYY");

        if (this.showingExpiredForBundles) {
          this.visibleBundles.push(bundle);
        } else if (bundleDate.isAfter(currentDate)) {
          this.visibleBundles.push(bundle);
        }
      }

      this.orderBundleUsage();
    },
    toggleZeroSpendServices() {
      this.visibleServices = [];

      this.showingZeroSpendForServices = !this.showingZeroSpendForServices;

      for (var index in this.mobileSummary.services) {
        var service = this.mobileSummary.services[index];

        if (!this.showingZeroSpendForServices) {
          if (service.servicePrice != 0) {
            this.visibleServices.push(service);
          }
        } else {
          if (service.servicePrice == 0) {
            this.visibleServices.push(service);
          }
        }
      }

      this.orderServices();
    },
    toggleExpiredServices() {
      this.visibleServices = [];
      var currentDate = moment().toDate();
      this.showingExpiredForServices = !this.showingExpiredForServices;

      this.showingZeroSpendForServices = true;

      for (var index in this.mobileSummary.services) {
        var service = this.mobileSummary.services[index];
        var sDate = null;
        var serviceDate = null;

        if (service.serviceExpiryDate != null) {
          sDate =
            service.serviceExpiryDate.dayOfMonth +
            "/" +
            service.serviceExpiryDate.monthValue +
            "/" +
            service.serviceExpiryDate.year;
          serviceDate = moment(sDate, "DD/MM/YYYY");
        }

        if (this.showingExpiredForServices) {
          this.visibleServices.push(service);
        } else if (serviceDate == null) {
          this.visibleServices.push(service);
        } else if (serviceDate.isAfter(currentDate)) {
          this.visibleServices.push(service);
        }
      }
      this.orderServices();
    },
    copyNumberToClipboard() {
      var input = document.createElement("input");
      input.setAttribute(
        "value",
        this.mobileSummary.mpnFixedLineDigitalAccountEtc
      );
      document.body.appendChild(input);
      input.select();
      var result = document.execCommand("copy");
      document.body.removeChild(input);

      this.snackbar = true;
      return result;
    },
    buildDateString(day, month, year) {
      var dayString = "" + day;
      var monthString = "" + month;

      if (dayString.length == 1) {
        dayString = "0" + dayString;
      }

      if (monthString.length == 1) {
        monthString = "0" + monthString;
      }

      return dayString + "/" + monthString + "/" + year;
    },
    getMobileDetails() {
      axios
        .get("/api/mbe/mobile-sum/" + this.$route.params.mobilenumber)
        .then((response) => {
          if (response.data == "") {
            this.mobileSummary.mpnFixedLineDigitalAccountEtc = "Nah";
            this.isLoading = false;
            return;
          }

          this.mobileSummary = response.data;

          this.currentDataUsage = (
            this.mobileSummary.currentBundleDataUsage /
            1024 /
            1024
          ).toFixed(2);

          for (
            var i = 0,
              keys = Object.keys(this.mobileSummary.bundleUsageSummary),
              ii = keys.length;
            i < ii;
            i++
          ) {
            this.lineChartOptions.series.push({
              name: keys[i],
              data: this.mobileSummary.bundleUsageSummary[keys[i]].map(
                (a) => a.totalBundleUsedGigabytes
              ),
            });

            if (
              i == 0 ||
              this.mobileSummary.bundleUsageSummary[keys[i]].length >
                this.lineChartOptions.xaxis.categories.length
            ) {
              this.lineChartOptions.xaxis.categories =
                this.mobileSummary.bundleUsageSummary[keys[i]].map((a) =>
                  new Date(a.bundleEffectiveDate).toLocaleDateString()
                );
            }
          }

          this.toggleExpiredBundles();
          this.toggleExpiredServices();

          this.userName = this.formatUserName(this.mobileSummary.userName);
          this.contractStatus = this.mobileSummary.contractStatus;
          this.tariffName = this.mobileSummary.tariffName;
          this.tariffDescription = this.mobileSummary.tariffDescription;

          for (var x in this.mobileSummary.billedCallPriceByClassType) {
            if (
              this.mobileSummary.billedCallPriceByClassType[x]
                .sumSpBilledCallPrice > 0
            ) {
              this.totalSpend +=
                this.mobileSummary.billedCallPriceByClassType[
                  x
                ].sumSpBilledCallPrice;
              this.chartOptions.labels.push(
                this.mobileSummary.billedCallPriceByClassType[x]
                  .callClassDescription
              );
              this.series.push(
                this.mobileSummary.billedCallPriceByClassType[x]
                  .sumSpBilledCallPrice
              );
            }
          }

          if (this.totalSpend == 0) {
            this.chartOptions.labels = [];
            this.series = [];
            this.chartOptions.labels.push("No Out Of Bundle Spend");
            this.series.push(0.00000001);
          }

          this.numberOfBundles = this.mobileSummary.bundleUsage.length;

          if (this.mobileSummary.contractStart != null) {
            this.contractStartDateString = this.buildDateString(
              this.mobileSummary.contractStart.dayOfMonth,
              this.mobileSummary.contractStart.monthValue,
              this.mobileSummary.contractStart.year
            );
          }

          if (this.mobileSummary.contractEnd != null) {
            this.contractEndDateString = this.buildDateString(
              this.mobileSummary.contractEnd.dayOfMonth,
              this.mobileSummary.contractEnd.monthValue,
              this.mobileSummary.contractEnd.year
            );
          }

          if (this.mobileSummary.tariffStartDate != null) {
            this.tarriffStartDateString = this.buildDateString(
              this.mobileSummary.tariffStartDate.dayOfMonth,
              this.mobileSummary.tariffStartDate.monthValue,
              this.mobileSummary.tariffStartDate.year
            );
          }

          if (this.mobileSummary.lastInvoiceDate != null) {
            this.lastInvoiceDateString = this.buildDateString(
              this.mobileSummary.lastInvoiceDate.dayOfMonth,
              this.mobileSummary.lastInvoiceDate.monthValue,
              this.mobileSummary.lastInvoiceDate.year
            );
          }

          if (this.mobileSummary.nextInvoiceDate != null) {
            this.nextInvoiceDateString = this.buildDateString(
              this.mobileSummary.nextInvoiceDate.dayOfMonth,
              this.mobileSummary.nextInvoiceDate.monthValue,
              this.mobileSummary.nextInvoiceDate.year
            );
          }

          if (this.mobileSummary.services != null) {
            this.numberOfServices = this.mobileSummary.services.length;
            this.numberOfServicesToShow = this.mobileSummary.services.length;
          }

          if (this.mobileSummary.recentRequests != null) {
            this.numberOfRequests = this.mobileSummary.recentRequests.length;
            this.numberOfRequestsToShow =
              this.mobileSummary.recentRequests.length;
          }

          if (this.mobileSummary.connectedDate != null) {
            this.connectedDateString = this.buildDateString(
              this.mobileSummary.connectedDate.dayOfMonth,
              this.mobileSummary.connectedDate.monthValue,
              this.mobileSummary.connectedDate.year
            );
          }

          if (this.mobileSummary.disconnectedDate != null) {
            this.disconnectedDateString = this.buildDateString(
              this.mobileSummary.disconnectedDate.dayOfMonth,
              this.mobileSummary.disconnectedDate.monthValue,
              this.mobileSummary.disconnectedDate.year
            );
          }

          this.formattedMobileNumber =
            this.mobileSummary.mpnFixedLineDigitalAccountEtc;

          this.formattedMobileNumber =
            this.formattedMobileNumber.substring(0, 4) +
            " " +
            this.formattedMobileNumber.substring(4, 7) +
            " " +
            this.formattedMobileNumber.substring(7);

          this.linkToFilteredInvoiceDataTable =
            "/table/invoice_line/" +
            this.mobileSummary.mpnFixedLineDigitalAccountEtc;
          this.linkToFilteredBundleDataTable =
            "/table/bundle_line/" +
            this.mobileSummary.mpnFixedLineDigitalAccountEtc;
          this.linkToFilteredServicesDataTable =
            "/table/service_report_line/" +
            this.mobileSummary.mpnFixedLineDigitalAccountEtc;
          this.linkToFilteredSubscriptionDataTable =
            "/table/data_report_line/" +
            this.mobileSummary.mpnFixedLineDigitalAccountEtc;
          this.linkToFilteredMobileSpendDataTable =
            "/table/cdr_summary_record/" +
            this.mobileSummary.mpnFixedLineDigitalAccountEtc;

          this.linkToServiceRequests =
            "/table/service_response_line/" +
            this.mobileSummary.mpnFixedLineDigitalAccountEtc;

          this.contractInformationInfoBlockPairs = [
            ["Status", this.contractStatus],
            ["Start", this.contractStartDateString],
            ["End", this.contractEndDateString],
          ];

          this.numberInfoBlockPairs = [
            ["User Name", this.userName],
            ["Corpo Code", this.mobileSummary.corpoCode],
            ["Cost Centre", this.mobileSummary.costCentre],
          ];

          this.tariffInformationInfoBlockPairs = [
            ["Tariff", this.tariffName],
            ["Package", this.tariffDescription],
            ["Start", this.tarriffStartDateString],
          ];

          this.invoiceInformationBlockPairs = [
            ["Next Invoice", this.nextInvoiceDateString],
            ["Last Invoice", this.lastInvoiceDateString],
            ["Last Amount", this.mobileSummary.paymentType],
          ];

          this.spendCapInformationBlockPairs = [
            ["Cap Used", this.mobileSummary.spendCapUsed.toFixed(2)],
            ["Cap Amount", this.mobileSummary.spendCapAmount.toFixed(2)],
            [
              "Cap Remaining",
              (
                this.mobileSummary.spendCapAmount -
                this.mobileSummary.spendCapUsed
              ).toFixed(2),
            ],
          ];

          this.subscriptionInformationBlockPairs = [
            ["Number", this.mobileSummary.subNumber.toString()],
            ["Connect", this.connectedDateString],
            ["Disconnect", this.disconnectedDateString],
          ];

          if (this.mobileSummary.hasSpendCap) {
            this.spendCapText = "Has Spend Cap";
          } else {
            this.spendCapText = "No Spend Cap";
          }

          this.isLoading = false;
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  beforeMount() {
    this.getMobileDetails();
  },
};
</script>
